// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Unauthorized_wrapper__2w9yu"};